export default {
	/**
	 * Resolves an array of connection objects from the API.
	 *
	 * @returns {Promise<array>}
	 */
	async all () {}
};
